var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popwrap modulewrap"},[_c(_vm.pagepop,_vm._g({tag:"component",attrs:{"poptype":_vm.poptype},on:{"update:poptype":_vm.updatepoptype}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }